import { http } from '@/utils/request';
import { parseResponse } from './common';
import { logger } from '@/utils/logger';

/**
 * 获取虚拟客服登录凭证
 * @param {Object} params - 登录参数
 * @param {string} params.serviceUserId - 服务用户ID
 * @param {string} params.conversationId - 会话ID
 * @returns {Promise<Object>} 登录凭证
 */
export const getVirtualServiceCredentials = async params => {
  try {
    logger.info('[loginApi] 获取虚拟客服登录凭证:', {
      serviceUserId: params.serviceUserId,
      conversationId: params.conversationId,
    });

    const url = '/api/chat/v1/service/login';
    const response = await http.post(url, {
      serviceUserId: params.serviceUserId,
      conversationId: params.conversationId,
    });

    const result = parseResponse(response);

    // 使用后端返回的 userId 字段，如果没有则从 virtualServiceUser.id 提取
    const userId = result?.userId || result?.virtualServiceUser?.id;

    logger.info('[loginApi] 获取登录凭证成功:', {
      result,
      sdkAppId: result?.sdkAppId,
      userId: userId,
      hasUserSig: !!result?.userSig,
      conversationId: result?.conversation?.id,
      virtualServiceUser: result?.virtualServiceUser,
    });

    // 返回标准化的凭证格式
    return {
      sdkAppId: result.sdkAppId,
      userId: userId,
      userSig: result.userSig,
      conversationId: result.conversation?.id,
      virtualServiceUser: result.virtualServiceUser,
      conversation: result.conversation,
    };
  } catch (error) {
    logger.error('[loginApi] 获取登录凭证失败:', error);
    throw new Error(`获取登录凭证失败: ${error.message}`);
  }
};

/**
 * 获取服务状态
 * @param {Object} params - 服务状态参数
 * @param {string} params.chatUserId - 聊天用户ID
 * @param {string} params.loginVirtualServiceId - 登录的虚拟客服ID（可选）
 * @returns {Promise<Object>} 服务状态结果
 */
export const getServiceStatus = async params => {
  try {
    logger.info('[loginApi] 获取服务状态:', {
      chatUserId: params.chatUserId,
      loginVirtualServiceId: params.loginVirtualServiceId,
    });

    const url = '/api/chat/v1/service/status';
    const requestData = {
      chatUserId: params.chatUserId,
    };

    // 如果有虚拟客服ID，则传递
    if (params.loginVirtualServiceId) {
      requestData.loginVirtualServiceId = params.loginVirtualServiceId;
    }

    // 调用原有的 status 接口
    const response = await http.post(url, requestData);
    const result = parseResponse(response);

    logger.info('[loginApi] 获取服务状态成功:', {
      conversationId: result?.conversation?.id,
      virtualServiceUserId: result?.virtualServiceUser?.id,
      buyerUserId: result?.buyerUser?.id,
    });

    return result;
  } catch (error) {
    logger.error('[loginApi] 获取服务状态失败:', error);
    throw new Error(`获取服务状态失败: ${error.message}`);
  }
};
